// Tour for the potential_customers project — the prospect-pipeline workspace:
// scraped/collected prospect data governed through the standard recipe, an
// LLM enrichment pass, and the Customers dashboard app on top.

export const potentialCustomersTour = {
  key: "project:potential_customers",
  title: "Potential Customers pipeline",
  description:
    "How the prospect workspace works: the customer dataset, its governance recipe, LLM enrichment, and the Customers dashboard app (including per-prospect demo links).",
  steps: [
    {
      title: "The prospect workspace",
      body:
        "This project governs our <b>potential-customers</b> data: companies collected from " +
        "scraping and research, normalized through the standard Cortex recipe, <b>enriched with an " +
        "LLM</b> (industry, org description, cortex-fit), and served to the team through the " +
        "Customers app. It's a real pipeline — the same machinery a customer project uses.",
    },
    {
      page: "data-sources",
      target: '[data-tour="page-data-sources"], main',
      title: "Sources — where prospects come from",
      body:
        "Collected prospect lists land here as sources. Each connection captures the schema, so " +
        "differently-shaped lists can still be governed into one canonical customer table.",
    },
    {
      page: "data-elements",
      target: '[data-tour="page-data-elements"], main',
      title: "Elements — the canonical customer fields",
      body:
        "Company name, domain, country, industry, org description, cortex-fit, demo URL… — the " +
        "canonical vocabulary every source maps into. Enrichment writes into governed elements too, " +
        "so derived fields are as versioned and auditable as scraped ones.",
    },
    {
      page: "source-mappings",
      target: '[data-tour="page-source-mappings"], main',
      title: "Mappings — many lists, one shape",
      body:
        "Each source's columns are mapped to the canonical elements. New list with different " +
        "headers? Map it and it joins the same governed dataset — no code.",
    },
    {
      page: "pipeline",
      target: '[data-tour="page-pipeline"], main',
      title: "Pipeline + enrichment",
      body:
        "The pipeline loads and validates prospect rows; the <b>enrichment</b> step then fills " +
        "LLM-derived fields (industry, description, cortex-fit) for rows that lack them. Re-running " +
        "is safe — enrichment only tops up what's missing.",
    },
    {
      page: "apps/cortex.customers.dashboard.view",
      target: '[data-tour="app-embed"], main',
      waitMs: 15000,
      title: "The Customers app",
      body:
        "The team's working surface, published from this project and reading the governed data " +
        "live: browse and search prospects, open a company's detail card, edit fields, and jump to " +
        "the <b>prepared per-prospect demo</b> via “Open prepared demo” when one exists (those " +
        "demos are themselves full Cortex projects, generated by the demo skill).",
    },
    {
      title: "Why it's built this way",
      body:
        "Dogfooding: the sales workspace runs on exactly what we sell — governed sources, mappings, " +
        "rules, a pipeline, and an app on live governed data. Anything demoed to a prospect here is " +
        "real.<br/><br/>Replay this tour any time via <b>Tutorial</b> in the sidebar, or take " +
        "“What is Cortex?” for the full product walkthrough.",
    },
  ],
};
